/** 能源 — 用电报表 /energy/electricity-report（electricityReport.vue、TableFocusMode.vue） */
export default {
  electricityReport: {
    dashboardTitle: '用电报表',
    tabStatistics: '租户用电统计',
    tabDetail: '租户用电明细',
    exportLoading: '导出中...',
    exportReport: '导出报表',
    filterStatPeriod: '统计时间',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    filterTenant: '选择租户',
    phTenant: '请选择租户',
    filterTenantType: '租户类型',
    tenantType0: '租户',
    tenantType1: '公区',
    tenantType2: '其他',
    tenantType3: '光伏',
    btnReset: '重置',
    btnSelectAll: '全选',
    btnDeselectAll: '取消全选',
    tooltipDeviceDetailStats: '设备明细仅支持单一租户查询,不支持全部租户',
    tooltipDeviceDetailSingle: '设备明细仅支持单一租户查询',
    deviceDetailSwitch: '设备明细',
    todayElecBadge: '今日电量：{total} 度（尖 {peak}+ 峰 {top}+ 平 {flat}+ 谷 {valley}）',
    todayFeeBadge: '今日电费：¥{value}',
    todayElecRealtime: '今日用电（实时）',
    todayFeeRealtime: '今日电费：¥{value}',
    periodTotalElec: '统计区间总电量',
    periodHistoryElec: '区间历史电量',
    todayIncreaseRealtime: '今日新增（实时）',
    periodTouComposition: '统计区间分时构成',
    touPeakShort: '尖',
    touTopShort: '峰',
    touFlatShort: '平',
    touValleyShort: '谷',
    mainTotalElec: '总电量(度)',
    subPeak: '尖电量(度)',
    subTop: '峰电量(度)',
    subFlat: '平电量(度)',
    subValley: '谷电量(度)',
    mainTotalFee: '总电费(元)',
    subIndoorFee: '室内电费(元)',
    subAcFee: '空调电费(元)',
    tipNoFloatingTitle: '总电费不含浮动费用项',
    tipNoFloatingShort: '不含浮动费用',
    loadingText: '数据加载中...',
    chartTrendTitle: '用电趋势分析',
    monitorTitle: '分时电量监控',
    legendTotalFee: '总电费',
    legendIndoorElec: '室内电量',
    legendAcElec: '空调电量',
    summaryTotalFee: '总电费',
    summaryIndoorElec: '室内电量',
    summaryAcElec: '空调电量',
    statPeak: '尖电量',
    statTop: '峰电量',
    statFlat: '平电量',
    statValley: '谷电量',
    seriesTotalFee: '总电费',
    seriesIndoorElec: '室内电量',
    seriesAcElec: '空调电量',
    seriesTodayCombo: '今日电量/电费',
    seriesPeakElec: '尖电量',
    seriesTopElec: '峰电量',
    seriesFlatElec: '平电量',
    seriesValleyElec: '谷电量',
    yAxisFee: '电费 (元)',
    yAxisElec: '电量 (度)',
    todayShort: '今日',
    tooltipTodayHeader: '今日',
    tooltipElecLabel: '电量:',
    tooltipFeeLabel: '电费:',
    unitYuan: '元',
    detailedData: '详细数据',
    todayDataNote: '说明：今日数据单独展示，不参与总计计算',
    fullscreenView: '全屏查看',
    fullscreenTitle: '详细数据 - 全屏查看',
    btnClose: '关闭',
    closeTitle: '关闭 (ESC)',
    filterDevice: '设备筛选',
    phDeviceSearch: '输入设备名称...',
    colDate: '日期',
    colTotalFeeYuan: '总电费（元）',
    colIndoorFeeYuan: '室内电费（元）',
    colAcFeeYuan: '空调电费（元）',
    colTotalKwh: '总电量（度）',
    colSysTotalKwh: '系统总电量（度）',
    colIndoorKwh: '室内电量（度）',
    colAcKwh: '空调电量（度）',
    colAirSysKwh: '空调系统电量（度）',
    colPeakKwh: '尖电量（度）',
    colTopKwh: '峰电量（度）',
    colFlatKwh: '平电量（度）',
    colValleyKwh: '谷电量（度）',
    colFeeYuan: '电费（元）',
    colDevice: '设备',
    colSettleWay: '结算方式',
    colFee: '费用',
    colElecGroup: '电量',
    colGrandTotal: '总计',
    colSpikeShort: '尖',
    colPeakShort: '峰',
    colFlatShort: '平',
    colValleyShort: '谷',
    colStartReading: '起始读数',
    colEndReading: '截止读数',
    colTime: '时间',
    colTotalElecShort: '总电量',
    emptyNoData: '暂无数据',
    emptyNoDeviceDetail: '暂无设备明细数据',
    emptyNoMatch: '未找到匹配的设备',
    emptyTryOtherKeyword: '试试其他关键词',
    sectionDetailTitle: '租户用电明细',
    sectionDeviceDetailTitle: '租户设备用电明细',
    colTenantId: '租户编号',
    colTenantName: '租户名称',
    colMeter: '电表',
    colDetail: '明细',
    colStatistics: '统计',
    colElecFee: '电费(元)',
    colElecKwh: '电量(度)',
    colPeakElec: '尖电量(度)',
    colTopElec: '峰电量(度)',
    colFlatElec: '平电量(度)',
    colValleyElec: '谷电量(度)',
    colPeakElecShort: '尖电量',
    colTopElecShort: '峰电量',
    colFlatElecShort: '平电量',
    colValleyElecShort: '谷电量',
    tenantAll: '全部',
    summaryTotal: '总计',
    statTypeDay: '日统计',
    statTypeMonth: '月统计',
    dateSpan100Days: '100天',
    dateSpan1Year: '1年',
    msgDateRangeLimit: '日统计最多只能选择{span}的数据',
    msgDateLimit100: '日统计最多只能选择100天的数据',
    msgTenantListFail: '获取租户列表失败',
    msgPickPeriod: '请选择统计时间',
    msgDeviceNeedTenant: '设备明细模式下请选择具体租户',
    msgPickTenant: '请选择租户',
    msgFetchFail: '获取数据失败',
    msgExportEmpty: '暂无数据可导出',
    msgExportEmptyDevice: '暂无设备明细数据可导出',
    msgExportOk: '导出成功！',
    msgExportFail: '导出失败',
    msgExportRetry: '请重试',
    msgDeviceAutoTenant: '设备明细模式已自动选择第一个租户',
    msgNoTenantAvailable: '暂无可用租户',
    errNoDeviceExport: '没有可导出的设备明细数据',
    errNoTenantMeterExport: '没有可导出的租户设备明细数据',
    expFilterTime: '统计时间: {start} 至 {end}',
    expFilterTenant: '租户: {tenant}',
    expFilterStatType: '统计类型: {type}',
    expFilterDeviceDetail: '设备明细',
    expJoinDetailLine: '{time}  |  {tenant}  |  {type}',
    expJoinDetailDevice: '{base}  |  {device}',
    settleWay0: '普通结算',
    settleWay1: '手动扣款',
    settleWay2: '系统补单',
    settleWay3: '浮动电价',
    settleWay4: '分摊结算',
    settleWay5: '设备扣款',
    pickerYesterday: '昨天',
    pickerThisWeek: '本周',
    pickerLastWeek: '上周',
    pickerThisMonth: '本月',
    pickerLastMonth: '上月',
    pickerLast3Months: '近三个月',
    pickerLastYear: '近一年',
    expColDate: '日期',
    expColTotalFee: '电费（元）',
    expColIndoorFee: '室内电费（元）',
    expColAcFee: '空调电费（元）',
    expColTotalKwh: '总电量（度）',
    expColSysTotalKwh: '系统总电量（度）',
    expColIndoorKwh: '室内电量（度）',
    expColAcKwh: '空调电量（度）',
    expColAirSysKwh: '空调系统电量（度）',
    expColPeakKwh: '尖电量（度）',
    expColTopKwh: '峰电量（度）',
    expColFlatKwh: '平电量（度）',
    expColValleyKwh: '谷电量（度）',
    expColDevice: '设备',
    expColSettleWay: '结算方式',
    expColFee: '费用',
    expColElec: '电量',
    expColRegion: '区域标签',
    expColTenantId: '租户编号',
    expColTenantName: '租户名称',
    expColMeter: '电表',
    expSheetStat: '租户用电统计',
    expSheetStatDevice: '租户用电统计-设备明细',
    expSheetDetail: '租户用电明细',
    expSheetDetailDevice: '租户用电明细-设备明细',
    listSep: '、',
    unitKwhDisplay: '度'
  }
}
